"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvertisingMachines = useAdvertisingMachines;
const react_1 = require("react");
const useAdvertising_1 = require("../context/useAdvertising");
function useAdvertisingMachines() {
    const { getMachines, setMachineAdvertising } = (0, useAdvertising_1.useAdvertising)();
    const [machines, setMachines] = (0, react_1.useState)([]);
    const [costPerMachine, setCostPerMachine] = (0, react_1.useState)(0);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const load = (0, react_1.useCallback)(async () => {
        setLoading(true);
        const result = await getMachines();
        setMachines(result.machines);
        setCostPerMachine(result.summary.costPerMachine);
        setLoading(false);
    }, [getMachines]);
    (0, react_1.useEffect)(() => {
        load();
    }, [load]);
    const setAdvertising = (0, react_1.useCallback)(async (machineId, advertisingEnabled) => {
        const updated = await setMachineAdvertising(machineId, advertisingEnabled);
        setMachines((prev) => prev.map((machine) => (machine.id === updated.id ? updated : machine)));
    }, [setMachineAdvertising]);
    // El resumen de coste se deriva de la lista para mantenerlo consistente con
    // los interruptores tras activar o desactivar la publicidad de una máquina.
    const summary = (0, react_1.useMemo)(() => {
        const enabledMachines = machines.filter((machine) => machine.advertisingEnabled).length;
        return {
            costPerMachine,
            enabledMachines,
            estimatedCost: enabledMachines * costPerMachine,
        };
    }, [machines, costPerMachine]);
    return { machines, summary, loading, refresh: load, setAdvertising };
}
